<template>
    <div class="ico_sum">
        <van-row class="ico_mrow">
            <van-col span="6" class="ico_mg">
                <router-link :to="`/Recommend?name=high`">
                    <van-row>
                        <van-col span="24" class="ico_img"><van-icon name="gem" color="#ff9900"/></van-col>
                    </van-row>
                    <van-row>
                        <van-col span="24" class="ico_title">{{$t("index.iconav1")}}</van-col>
                    </van-row>
                </router-link>
            </van-col>
            <van-col span="6" class="ico_mg">
                <router-link :to="`/Share`">
                    <van-row>
                        <van-col span="24" class="ico_img"><van-icon name="friends-o" color="red"/></van-col>
                    </van-row>
                    <van-row>
                        <van-col span="24" class="ico_title">{{$t("index.iconav2")}}</van-col>
                    </van-row>
                </router-link>
            </van-col>
            <van-col span="6" class="ico_mg">
                <router-link :to="`/Recommend?name=new`">
                    <van-row>
                        <van-col span="24" class="ico_img"><van-icon name="star" color="#ff9900"/></van-col>
                    </van-row>
                    <van-row>
                        <van-col span="24" class="ico_title">{{$t("index.iconav3")}}</van-col>
                    </van-row>
                </router-link>
            </van-col>
            <van-col span="6" class="ico_mg">
                <router-link :to="`/Information?name=gift`">
                    <van-row>
                        <van-col span="24" class="ico_img"><van-icon name="point-gift" color="red"/></van-col>
                    </van-row>
                    <van-row>
                        <van-col span="24" class="ico_title">{{$t("index.iconav4")}}</van-col>
                    </van-row>
                </router-link>
            </van-col>
        </van-row>
        <van-row class="ico_mrow">
            <van-col span="6" class="ico_mg">
                <router-link :to="`/Information?name=safe`">
                    <van-row>
                        <van-col span="24" class="ico_img"><van-icon name="youzan-shield" color="red"/></van-col>
                    </van-row>
                    <van-row>
                        <van-col span="24" class="ico_title">{{$t("index.iconav5")}}</van-col>
                    </van-row>
                </router-link>
            </van-col>
            <van-col span="6" class="ico_mg">
                <router-link :to="`/Information?name=team`">
                    <van-row>
                        <van-col span="24" class="ico_img"><van-icon name="cluster-o" color="#ff9900"/></van-col>
                    </van-row>
                    <van-row>
                        <van-col span="24" class="ico_title">{{$t("index.iconav6")}}</van-col>
                    </van-row>
                </router-link>
            </van-col>
            <van-col span="6" class="ico_mg" @click="sign">
                <van-row>
                    <van-col span="24" class="ico_img"><van-icon name="sign" color="red" /></van-col>
                </van-row>
                <van-row>
                    <van-col span="24" class="ico_title">{{$t("index.iconav7")}}</van-col>
                </van-row>
            </van-col>
            <van-col span="6" class="ico_mg">
                <router-link :to="`/Information?name=about`">
                    <van-row>
                        <van-col span="24" class="ico_img"><van-icon name="friends" color="#ff9900"/></van-col>
                    </van-row>
                    <van-row>
                        <van-col span="24" class="ico_title">{{$t("index.iconav8")}}</van-col>
                    </van-row>
                </router-link>
            </van-col>
        </van-row>
    </div>
</template>

<script>
    export default {
        name: "Iconarea",
        methods:{
            sign(){
                this.getReq('/sign').then((res)=>{
                    if(res.code==200){
                        this.$toast(res.message);
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .ico_sum{
        overflow: hidden;
        width: 100%;
        height: 0;
        padding-bottom: 45%;
        .ico_mrow{
            margin: 10px;
            .ico_mg{
                .ico_img{
                    font-size: 38px;
                }
                .ico_title{
                    color: #666;
                    font-weight: bold;
                    font-size: 14px;
                }
            }
        }
    }
</style>
